<template>
  <div class="content">
    <ArtistSelect
      @memberChangeEvent="getArtistInfo"
      :show-all-units="true"
      :is-filter="true"
      :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
      :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
    />
    <div class="row">
      <div class="col-md-10">
        <SimpleSearch :keyword="keyword" @simpleSearchEvent="setKeyword" />
      </div>
      <div class="col-md-2">
        <el-select class="select-primary" size="large" placeholder="스케줄타입" v-model="scheduleType" @change="getList">
          <el-option v-for="option in scheduleTypes" class="select-primary" :value="option.id" :label="option.name" :key="option.name"></el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
        <el-date-picker v-model="currentMonth" type="month" placeholder="Pick a month"> </el-date-picker>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-radio name="calendar" inline v-model="viewType">캘린더</base-radio>
        <base-radio name="list" inline v-model="viewType">리스트</base-radio>
      </div>
    </div>
    <div v-show="viewType === 'calendar'" class="row">
      <div class="col-12">
        <full-calendar
          id="fullCalendar"
          v-bind="calendarOptions"
          :events="events"
          contentHeight="auto"
          ref="fullCalendar"
          @eventClick="onEventClick"
          @datesRender="datesRender"
        />
      </div>
    </div>
    <div v-show="viewType === 'list'" class="row">
      <div class="col-md-12">
        <FullCalendarHeader :year="year" :month="month" @change="onChangeMonth" @goFormPage="goFormPage" @exportExcel="exportExcel" />
      </div>
      <div class="col-md-12">
        <el-table :data="events">
          <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
          <el-table-column :min-width="110" align="center" label="펀딩요청">
            <div slot-scope="props">
              <Badge v-if="props.row.fundingRequestCount > 0" type="danger">{{ props.row.fundingRequestCount }}</Badge>
            </div>
          </el-table-column>
          <el-table-column :min-width="135" align="right" label="공유페이지">
            <div slot-scope="props">
              <base-button @click.native="goShareUrl(props.row.idHash)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
          <el-table-column :min-width="135" align="right" label="상세">
            <div slot-scope="props">
              <base-button @click.native="handleEdit(props.row.id, props.row.unitId)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Endpoints from "@/common/Endpoints";

import { Table, TableColumn } from "element-ui";

import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import SimpleSearch from "@/pages/Components/SimpleSearch.vue";
import FullCalendarHeader from "@/pages/Components/FullCalendarHeader.vue";
import { Badge } from "@/components";
import * as moment from "moment";
import { URLUtils } from "@/util/URLUtils";
import * as _ from "lodash";
import * as XLSX from "xlsx";

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();

export default {
  components: {
    FullCalendar,
    ArtistSelect,
    SimpleSearch,
    FullCalendarHeader,
    Badge,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    const { keyword, scheduleType } = this.$route.query;
    this.keyword = keyword || null;
    this.scheduleType = parseInt(scheduleType, 10) || null;
    await this.getScheduleTypes();
  },
  watch: {
    currentMonth() {
      const calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(this.currentMonth);
      this.year = this.currentMonth.getFullYear();
      this.month = this.currentMonth.getMonth() + 1;
    },
  },
  data() {
    return {
      unitId: "",
      memberId: "",
      keyword: null,
      currentMonth: null,
      year: y,
      month: m + 1,
      viewType: "calendar",
      scheduleType: null,
      scheduleTypes: [],
      colors: ["#815545", "#ff324b", "#fecd00", "#2bd2ca", "#7339ff", "#a8a8a8", "#2b329b", "#00b2ff"],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "startTime",
          label: "시작일",
          minWidth: 150,
        },
        {
          prop: "endTime",
          label: "종료일",
          minWidth: 150,
        },
        {
          prop: "oriTitle",
          label: "제목",
          minWidth: 120,
        },
        {
          prop: "artistName",
          label: "아티스트명",
          minWidth: 120,
        },
        {
          prop: "memberName",
          label: "관련멤버",
          minWidth: 120,
        },
        {
          prop: "type",
          label: "타입",
          minWidth: 120,
        },
      ],
      events: [],
      calendarOptions: {
        customButtons: {
          registration: {
            text: "등록",
            click: this.goFormPage,
          },
        },
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        theme: true,
        defaultView: "dayGridMonth",
        header: {
          left: "title",
          // center: "dayGridMonth,timeGridWeek,timeGridDay",
          right: "prev,next,today,registration",
        },
        defaultDate: today,
        selectable: true,
        selectHelper: true,
        views: {
          month: {
            // name of view
            titleFormat: {
              month: "long",
              year: "numeric",
            },
            // other view-specific options here
          },
          week: {
            titleFormat: {
              month: "long",
              day: "2-digit",
              year: "numeric",
            },
          },
          day: {
            titleFormat: {
              day: "2-digit",
              month: "long",
              year: "numeric",
            },
          },
        },
        // editable: true,
        eventLimit: true, // allow "more" link when too many events

        // color classes: [ event-blue | event-azure | event-green | event-orange | event-red ]
        events: self.events,
      },
    };
  },
  methods: {
    async getScheduleTypes() {
      return this.$axios.get("/schedule/scheduleTypes").then((res) => {
        this.scheduleTypes = res.data.data;
        this.scheduleTypes.unshift({ id: null, name: "전체" });
      });
    },
    onChangeMonth(date) {
      const calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(date.toDate());
    },
    onEventClick(event) {
      const scheduleId = event.event.id;
      const schedule = _.find(this.events, { id: parseInt(scheduleId, 10) });

      this.$router.push(`/schedules/scheduleForm?scheduleId=${scheduleId}&unitId=${schedule.unitId}`);
    },

    handleEdit(scheduleId, unitId) {
      this.$router.push(`/schedules/scheduleForm?scheduleId=${scheduleId}&unitId=${unitId}`);
    },

    goShareUrl(idHash) {
      window.open(`${Endpoints.sharePageUrl}/s/${idHash}`);
    },

    goFormPage() {
      this.$router.push(`/schedules/scheduleForm?unitId=${this.unitId}`);
    },
    exportExcel() {
      const data = this.events.map((event) => {
        return {
          id: event.id,
          idHash: event.idHash,
          artistName: event.artistName,
          memberName: event.memberName,
          type: event.type,
          title: event.title,
          startTime: event.startTime,
          endTime: event.endTime,
        };
      });
      const excelData = XLSX.utils.json_to_sheet(data);
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, excelData, "스케줄");
      XLSX.writeFile(workBook, "export.xlsx");
    },
    async datesRender() {
      const calendarApi = this.$refs.fullCalendar.getApi();
      this.year = calendarApi.getDate().getFullYear();
      this.month = calendarApi.getDate().getMonth() + 1;
      await this.getList();
    },

    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;

      await this.getList();
    },

    async setKeyword(param) {
      if (param.keyword !== "") {
        this.keyword = param.keyword;
      } else {
        this.keyword = null;
      }
      await this.getList();
    },
    async getList() {
      if (this.unitId !== null && !this.unitId) {
        return;
      }
      const startTime = moment(`${this.year}-${this.month}-1`, "YYYY-M-D").toISOString();
      const endTime = moment(`${this.year}-${this.month}-1`, "YYYY-M-D").endOf("month").toISOString();

      const queryParams = {
        unitId: this.unitId || undefined,
        artistId: this.memberId || undefined,
        keyword: this.keyword || undefined,
        scheduleType: this.scheduleType,
      };
      if (this.unitId !== null) {
        const path = `/schedules/schedules?${URLUtils.objectToQueryString(queryParams)}`;
        if (this.$route.fullPath !== path) {
          try {
            await this.$router.push(path);
          } catch (ex) {}
        }
      }
      return this.$axios
        .get("/schedule", {
          params: {
            unitId: this.unitId,
            memberId: this.memberId,
            keyword: this.keyword,
            year: this.year,
            month: this.month,
            typeId: this.scheduleType,
            startTime,
            endTime,
          },
        })
        .then((res) => {
          this.events = [];
          const data = res.data.data;
          data.forEach((d) => {
            const obj = {};

            for (let i = 0; i < this.scheduleTypes.length; i++) {
              const type = this.scheduleTypes[i];
              if (d.typeId === type.id) {
                obj.type = type.name;
                break;
              }
            }
            obj.id = d.scheduleId;
            if (this.unitId) {
              obj.title = `[${obj.type}] ${d.title}`;
            } else {
              obj.title = `[${obj.type} ${d.artistName}] ${d.title}`;
            }
            obj.unitId = d.unitId;
            obj.oriTitle = d.title;
            obj.allDay = d.isAllDay === 1;
            obj.members = d.members;
            obj.start = moment(d.startTime).format("Y-MM-DDTHH:mm:ss.000Z");
            obj.end = moment(d.endTime).format("Y-MM-DDTHH:mm:ss.100Z");
            obj.startTime = moment(d.startTime).format("Y-MM-DD HH:mm:ss");
            obj.endTime = moment(d.endTime).format("Y-MM-DD HH:mm:ss");
            obj.color = this.colors[d.typeId - 1];
            obj.idHash = d.idHash;
            obj.artistName = d.artistName;
            obj.fundingRequestCount = d.fundingRequestCount ?? 0;
            if (obj.members.length > 0) {
              obj.memberName = "";

              obj.members.forEach((item) => {
                obj.memberName += item.name;
              });
            } else {
              obj.memberName = "전체";
            }
            this.events.push(obj);
          });
        });
    },
  },
};
</script>
<style>
#fullCalendar {
  min-height: 400px;
}

.el-loading-spinner .path {
  stroke: #66615b !important;
}
</style>
